import { Typography, TypographyProps } from "@mui/material";
import styled from "styled-components";
import YLLWLOGOPNG from "../assets/Yllw_Inventory.svg";
import { useEffect, useRef } from "react";
export const SoecoHeader = (props: TypographyProps) => {
    const headingRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        headingRef.current?.focus();
        setTimeout(() => {
            headingRef.current?.blur();
        }, 0);
    }, []);

    return (
        <>
            <HeaderWrapper>
                <Logo src={YLLWLOGOPNG} />
                <Typography
                    ref={headingRef}
                    component="h1"
                    variant="h1"
                    tabIndex={0}
                    sx={{
                        fontFamily: "'Yllw Sans a1 241219', sans-serif",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    fontSize={14}
                    fontWeight={"500"}
                    color="#8c8c8c"
                    noWrap
                >
                    {props.children}
                </Typography>
            </HeaderWrapper>
        </>
    );
};
const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 3px;
`;
const StyledTypography = styled(Typography)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Logo = styled.img`
    width: 120px;
    height: 22px;
    top: 30px;
    left: 135px;
    margin-top: 20px;
`;
